import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import { routes } from "../../../utlis/admin/routes.utlis";
import ApiService from "../../../core/services/ApiService";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
import { encode } from "base-64";
import { totalPageCalculator, LIMIT } from "../../../utlis/common.utlis";

const Page = () => {
  const navigate = useNavigate();
  const [jobs, setJob] = useState([]);
  const [categories, setCategory] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    name: "",
    status: "",
    category: "",
    defaultDate: null,
    startDate: null,
    endDate: null,
    month: "",
    quarter: "",
    year: "",
  });
  const [dateType, setDateType] = useState("");

  // Handle Filter Changes
  const handleFilterChange = (e, date = null) => {
    const { name, value } = e.target || {};
    const formattedDate = date ? moment(date).format("yyyy-MM-DD") : null;

    // Update the filters state
    setFilters((prevFilters) => {
      const updatedFilters = {
        ...prevFilters,
        [name]: date === null ? value : formattedDate, // Use `value` for non-date fields, `formattedDate` for date fields
      };
      return updatedFilters;
    });
  };

  // Fetch Data Based on Filters
  const fetchFilteredData = async (filterParams) => {
    const query = new URLSearchParams({
      page: pageNum,
      limit: LIMIT,
      search: filterParams.name,
      status: filterParams.status,
      categoryid: filterParams.category,
      defaultDate: filterParams.defaultDate,
      startDate: filterParams.startDate,
      endDate: filterParams.endDate,
      month: filterParams.month,
      quarter: filterParams.quarter,
      year: filterParams.year,
    }).toString();

    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(`${api.careJobList}?${query}`);
    if (response.data.status && response.data.statusCode === 200) {
      setJob(response.data.data.jobs);
      setTotal(response.data.data.total);
    } else {
      setJob([]);
    }
    setLoading(false);
  };

  // Handle Date Type Change
  const handleDateTypeChange = (e) => {
    const value = e.target.value;

    setFilters((prevFilters) => ({
      ...prevFilters,
      defaultDate: null,
      startDate: null,
      endDate: null,
      month: value === "month" ? prevFilters.month : "",
      quarter: value === "quarter" ? prevFilters.quarter : "",
      year: value === "year" || value === "month" || value === "quarter" ? prevFilters.year : "",
    }));

    setDateType(value);
  };

  // Handle Search Button Click
  const handleSearch = () => {
    fetchFilteredData(filters);
  };

  // Handle Reset Button Click
  const handleReset = () => {
    const resetFilters = {
      name: "",
      status: "",
      category: "",
      type: "",
      state_id: "",
      startDate: null,
      endDate: null,
      month: "",
      quarter: "",
      year: "",
    };

    setFilters(resetFilters);
    setDateType("");
    setPageNum(1);

    fetchFilteredData(resetFilters);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const query = new URLSearchParams({
        page: pageNum,
        limit: LIMIT,
      }).toString();

      setLoading(true);
      const response = await ApiService.getAPIWithAccessToken(`${api.careJobList}?${query}`);
      if (response.data.status && response.data.statusCode === 200) {
        setJob(response.data.data.jobs);
        setTotal(response.data.data.total);
      } else {
        setJob([]);
      }
      setLoading(false);
    };

    fetchData();
    getCategoryList(api.categoryList);

  }, [pageNum]);

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  /* 
  useEffect(() => {
    window.scrollTo(0, 0);
    getJobList(
      api.careJobList +
      `?page=${pageNum}&limit=${LIMIT}&status=${startStatus}&search=${startName}&start_date=${startDate ?? ""
      }&categoryid=${startCategory}&subcategoryid=${startSubCategory}`
    );
    getCategoryList(api.categoryList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]);

   */
  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="heading-title">Care Jobs</h3>
        </div>

        <div className="care-title-header">
          <div className="cc-search-filter wd100">
            <div className="row g-2">
              <div className="col-md-3">
                <div className="form-group search-form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={handleFilterChange}
                    value={filters.name || ""}
                  />
                  <span className="search-icon">
                    <i className="cc-input-group-text  mdi mdi-magnify"></i>
                  </span>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="status"
                    onChange={handleFilterChange}
                    value={filters.status || ""}
                  >
                    <option value="">Select Status</option>
                    <option value="0">Pending</option>
                    <option value="1">Ongoing</option>
                    <option value="3">Cancelled</option>
                    <option value="4">Completed</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="category"
                    onChange={handleFilterChange}
                    value={filters.category || ""}
                  >
                    <option value="">Select Category</option>
                    {categories.length !== 0
                      ? categories.map((ele, indx) => {
                        return (
                          <option key={indx} value={ele.id}>
                            {ele.name ?? "NA"}
                          </option>
                        );
                      })
                      : null}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <DatePicker
                    toggleCalendarOnIconClick
                    showIcon
                    dateFormat={"MM-dd-yyyy"}
                    selected={filters.defaultDate}
                    onChange={(date) =>
                      handleFilterChange({ target: { name: "defaultDate" } }, date)
                    }
                    className="DatePicker-control"
                    isClearable
                    autoComplete="off"
                    placeholderText="Select Date"
                  />

                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="date_type"
                    onChange={handleDateTypeChange}
                    value={dateType || ""}
                  >
                    <option value="">Choose Date Range</option>
                    <option value="date">Date</option>
                    <option value="month">Month</option>
                    <option value="quarter">Quarter</option>
                    <option value="year">Year</option>
                  </select>
                </div>
              </div>

              {/* Conditionally Render Fields Based on Date Type */}
              {dateType === "date" && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {/* From Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.startDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "startDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="From Date"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      {/* To Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.endDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "endDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="To Date"
                      />
                    </div>
                  </div>
                </>
              )}

              {dateType === "month" && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="month"
                        onChange={handleFilterChange}
                        value={filters.month || ""}
                      >
                        <option value="">Select Month</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        onChange={handleFilterChange}
                        value={filters.year || ""}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "quarter" && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="quarter"
                        onChange={(e) => handleFilterChange(e)}
                        value={filters.quarter || ""}
                      >
                        <option value="">All Quarters</option>
                        <option value="1">Q1 (Jan - Mar)</option>
                        <option value="2">Q2 (Apr - Jun)</option>
                        <option value="3">Q3 (Jul - Sep)</option>
                        <option value="4">Q4 (Oct - Dec)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        onChange={(e) => handleFilterChange(e)}
                        value={filters.year || ""}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "year" && (
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="year"
                      onChange={(e) => handleFilterChange(e)}
                      value={filters.year || ""}
                    >
                      <option value="">Select Year</option>
                      {Array.from({ length: 10 }, (_, i) => {
                        const year = new Date().getFullYear() - i;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              )}

              <div className="col-md-2">
                <div className="form-group">
                  <button
                    className="btn btn-gr p-1"
                    onClick={handleSearch}
                  >
                    <i className="cc-input-group-text mdi mdi-magnify"></i>
                  </button> &nbsp;
                  <button
                    className="btn btn-re p-1"
                    onClick={handleReset}
                  >
                    <i className="cc-input-group-text mdi mdi-restore"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="cc-table-card">
          <div className="table-responsive ">
            <table className="table">
              <thead>
                <tr>
                  <th> Name </th>
                  <th> Job ID </th>
                  <th> Category </th>
                  <th> Start Date </th>
                  <th> Time</th>
                  <th> Frequency </th>
                  <th> Status </th>
                  <th> Action </th>
                </tr>
              </thead>
              <tbody>
                {jobs.length !== 0 ? (
                  jobs.map((ele, indx) => {
                    return (
                      <tr key={indx}>
                        <td className="text-capitalize">
                          {ele.first_name ?? "NA"}
                        </td>
                        <td>{ele.job_id ?? "NA"}</td>
                        <td>{ele.category ?? "NA"}</td>
                        <td>{moment(ele.start_date).format("MM-DD-yyyy")}</td>
                        <td>{ele.start_time}</td>
                        <td>
                          {ele.frequency === "O"
                            ? "One Time"
                            : ele.frequency === "W"
                              ? "Repeat Weekly"
                              : "Repeat Monthly"}
                        </td>
                        <td>{ele.job_status ?? "NA"}</td>
                        <td>
                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.careJobDetails, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            <label
                              className="badge badge-gradient-success"
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa fa-eye"></i>
                            </label>
                          </Link>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="text-center">
                    <td colSpan="8">
                      <div>
                        <p>No care jobs found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="d-flex align-items-center justify-content-center mt-3">
              {jobs.length !== 0 ? (
                <div className="care-table-pagination">
                  <ul className="care-pagination">
                    {pageNum !== 1 && (
                      <li
                        className="disabled"
                        id="example_previous"
                        onClick={() => setPageNum(pageNum - 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="0"
                          tabIndex="0"
                          className="page-link"
                        >
                          Previous
                        </Link>
                      </li>
                    )}

                    {totalPageCalculator(total, LIMIT).length === 1
                      ? null
                      : totalPageCalculator(total, LIMIT).map(
                        (pageNo, indx) => {
                          return (
                            <li
                              className={pageNo === pageNum ? "active" : ""}
                              key={indx}
                              onClick={() => setPageNum(pageNo)}
                            >
                              <Link to="" className="page-link">
                                {pageNo}
                              </Link>
                            </li>
                          );
                        }
                      )}

                    {pageNum !== Math.ceil(total / LIMIT) && (
                      <li
                        className="next"
                        id="example_next"
                        onClick={() => setPageNum(pageNum + 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="7"
                          tabIndex="0"
                          className="page-link"
                        >
                          Next
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
